import validasiKeberadaan from '@/composables/validasiKeberadaan'
import { intThousand } from '@/libs/helper'
import master from '@/composables/master'

export default class GeneralApi {
  constructor(g) {
    this.g = g
  }

  getKobar(kibKobar, kobar = '', kolok = null, length = 10) {
    const params = {
      kib: kibKobar,
      cari: kobar,
      kolok,
      length,
    }

    return master.getKobar(this.g, params)
  }

  getPdUkpd(wilayah = null) {
    const params = {
      wilayah,
    }
    return master.getPdUpd(this.g, params)
  }

  getNoReg(kib, rekonTahun, rekonKode, kolok, kobar) {
    const params = {
      kib,
      tahun_rekon: rekonTahun,
      kode_rekon: rekonKode,
      kolok,
      kobar,
    }
    return master.getNoReg(this.g, params)
  }

  async getBmdById(idBmd) {
    const response = await validasiKeberadaan.getBmdDetail(this.g, {
      id: idBmd,
      username: this.g.$cookies.get('username'),
    })
    const { data, code } = response
    if (code != 200) return {}

    const {
      id,
      KOLOK,
      nama_pd_ukpd_siera: namaPdUkpdSiera,
      kib: kibVal,
      kobar_108,
      nabar_108,
      noreg_108,
      HARGA,
      TGLOLEH,
      UKURAN,
      ALAMAT,
      SATUAN,
      rekon_kode,
      rekon_tahun,
      alasan_tidak_ada,
      alasan_tidak_ada_p,
      alasan_tidak_ada_note,
      dk_ket_beton,
      dk_ket_beton_note,
      dk_peruntukan_bmd,
      di_m_kobar_a: diMKobarA,
      di_m_ukuran: diMUkuran,
      di_m_ukuran_a: diMUkuranA,
      di_m_bertingkat: diMBertingkat,
      di_m_bertingkat_a: diMBertingkatA,
      di_m_lantai_tdk: diMLantaiTdk,
      di_m_lantai_tdk_use: diMLantaiTdkUse,
      di_m_lantai_tdk_not: diMLantaiTdkNot,
      di_m_sk_penggunaan: diMSkPenggunaan,
      di_sk_penggunaan_tahun,
      di_sk_penggunaan_no,
      di_penggunaan,
      penggunaan_pihak_lain: penggunaanPihakLain,
      penggunaan_opd: penggunaanOpd,
      di_gedung_bangunan_diatas_tanah_milik: diGedungBangunanDiatasTanahMilik,
      di_gedung_bangunan_diatas_tanah_milik_tercatat: diGedungBangunanDiatasTanahMilikTercatat,
      di_gedung_bangunan_diatas_tanah_milik_sebut: diGedungBangunanDiatasTanahMilikSebut,
      di_kd_prop,
      di_kd_rayon,
      di_kd_kec,
      di_kd_kel,
      di_kodepos: diKodepos,
      di_jalan: diJalan,
      di_no_jalan: diNoJalan,
      di_rt: diRt,
      di_rw: diRw,
      di_indikasi_ganda: diIndikasiGanda,
      di_indikasi_ganda_dengan: diIndikasiGandaDengan,
      di_indikasi_ganda_sebutkan: diIndikasiGandaSebutkan,
      di_m_kobar_kib: diMKobarKib,
      di_gedung_bangunan_diatas_tanah_milik_opd: diGedungBangunanDiatasTanahMilikOpd,
      di_gedung_bangunan_diatas_tanah_milik_kobar: diGedungBangunanDiatasTanahMilikKobar,
      di_gedung_bangunan_diatas_tanah_milik_noreg: diGedungBangunanDiatasTanahMilikNoreg,
      di_nm_spesifikasi_barang: diNmSpesifikasiBarang,
      di_indikasi_gabungan: diIndikasiGabungan,
      di_indikasi_gabungan_keterangan: diIndikasiGabunganKeterangan,
      di_pp_at_ada,
      di_pp_at_ada_digunakan,
      di_pp_at_ada_digunakan_oleh,
      di_pp_bm_ada,
      di_pp_bm_ada_digunakan,
      di_pp_bm_ada_digunakan_oleh,
      di_pp_ht_ada,
      di_pp_ht_ada_digunakan,
      di_pp_ht_ada_digunakan_oleh,
      di_pengamanan_fisik,
      di_pengamanan_fisik_child,
      di_pengamanan_fisik_note,
      keberadaan: keberadaanVal,
      tbt_barat,
      tbt_selatan,
      tbt_timur,
      tbt_utara,
    } = data
    const defaultVNull = { text: '-- Pilih Salah Satu --', value: null }

    let dataKobar
    let satuanSeharusnya = SATUAN
    if (diMKobarA) {
      dataKobar = await this.getKobar(diMKobarKib || kibVal, '', null, 100000)
      dataKobar.rows.map(item => {
        if (item.kode == diMKobarA) satuanSeharusnya = item.kodeSatuan
        return {
          kodeSatuan: item.kodeSatuan,
        }
      })
    }

    let index
    let isGedungBangunanTanahMilikTercatat
    let gedungBangunanTanahMilikPdUkpd
    let gedungBangunanTanahMilikKobar
    let dataGedungBangunanTanahMilikKobar
    let dataGedungBangunanTanahMilikRegister
    let gedungBangunanTanahMilikRegister
    let gedungBangunanTanahMilikKeterangan
    let gedungBangunanTanahMilikSebutkan
    if (diGedungBangunanDiatasTanahMilik == 1) {
      isGedungBangunanTanahMilikTercatat = diGedungBangunanDiatasTanahMilikTercatat

      if (diGedungBangunanDiatasTanahMilikTercatat == 1) {
        const dataPdUkpd = await this.getPdUkpd()
        dataPdUkpd.unshift(defaultVNull)
        index = dataPdUkpd.findIndex(item => item.value == diGedungBangunanDiatasTanahMilikOpd)

        gedungBangunanTanahMilikPdUkpd = index >= 0 ? dataPdUkpd[index] : defaultVNull

        index = -1
        const resKobar = await this.getKobar(
          'A',
          '',
          diGedungBangunanDiatasTanahMilikOpd,
          100000,
        )
        dataGedungBangunanTanahMilikKobar = resKobar.rows.map(
          (item, i) => {
            if (item.kode == diGedungBangunanDiatasTanahMilikKobar) index = i
            return {
              text: `${item.kode} :: ${item.nama}`,
              value: item.kode,
              nama: item.nama,
            }
          },
        )

        gedungBangunanTanahMilikKobar = index >= 0
          ? dataGedungBangunanTanahMilikKobar[index]
          : defaultVNull

        const resNoReg = await this.getNoReg(
          'A',
          rekon_tahun,
          rekon_kode,
          gedungBangunanTanahMilikPdUkpd.value,
          gedungBangunanTanahMilikKobar
            ?? gedungBangunanTanahMilikKobar
            ? gedungBangunanTanahMilikKobar.value
            : null,
        )
        dataGedungBangunanTanahMilikRegister = resNoReg.rows
        if (dataGedungBangunanTanahMilikRegister) {
          dataGedungBangunanTanahMilikRegister = dataGedungBangunanTanahMilikRegister.map((item, i) => {
            if (item.noreg_108 == diGedungBangunanDiatasTanahMilikNoreg) index = i
            return {
              text: `${item.noreg_108} :: ${item.ALAMAT}`,
              value: item.noreg_108,
            }
          })

          gedungBangunanTanahMilikRegister = index >= 0
            ? dataGedungBangunanTanahMilikRegister[index]
            : defaultVNull
        }
      } else gedungBangunanTanahMilikKeterangan = diGedungBangunanDiatasTanahMilikSebut
    } else if (
      diGedungBangunanDiatasTanahMilik == 2
      || diGedungBangunanDiatasTanahMilik == 3
      || diGedungBangunanDiatasTanahMilik == 4
    ) gedungBangunanTanahMilikSebutkan = diGedungBangunanDiatasTanahMilikSebut

    let indikasiGabunganKeterangan
    if (diIndikasiGabungan) indikasiGabunganKeterangan = diIndikasiGabunganKeterangan

    const digunakanBersama = []
    const pdUkpd = []
    const digunakanUntuk = []
    if (penggunaanOpd) {
      if (penggunaanOpd.length > 0) {
        digunakanBersama.push('1')

        for (let i = 0; i < penggunaanOpd.length; i += 1) {
          const { di_penggunaan_opd, di_penggunaan_untuk } = penggunaanOpd[i]

          pdUkpd.push({
            value: { text: di_penggunaan_opd, value: di_penggunaan_opd },
          })
          digunakanUntuk.push({ value: di_penggunaan_untuk })
        }
      }
    }
    const pemanfaat = []
    if (penggunaanPihakLain) {
      if (penggunaanPihakLain.length > 0) {
        digunakanBersama.push('0')

        for (let i = 0; i < penggunaanPihakLain.length; i += 1) {
          const {
            di_penggunaan_pemanfaat,
            di_penggunaan_pemanfaat_nama,
            di_penggunaan_pemanfaat_dasar,
            di_penggunaan_pemanfaat_dasar_type,
          } = penggunaanPihakLain[i]

          pemanfaat.push({
            value: di_penggunaan_pemanfaat,
            namaPemanfaat: di_penggunaan_pemanfaat_nama,
            dasarPenggunaan: di_penggunaan_pemanfaat_dasar,
            dasarPenggunaanTipe: di_penggunaan_pemanfaat_dasar_type,
          })
        }
      }
    }
    return {
      id,
      kolok: `${KOLOK}::${namaPdUkpdSiera}`,
      kib: kibVal,
      kobar: kobar_108,
      nabar: nabar_108,
      kodeRegisterBarang: noreg_108,
      nilaiPerolehan: HARGA
        ? intThousand(HARGA.toString().replace('.', ','))
        : '',
      tahunPerolehan: TGLOLEH,
      keberadaan: keberadaanVal,
      tanda2BatasTanahUtara: tbt_utara,
      tanda2BatasTanahTimur: tbt_timur,
      tanda2BatasTanahSelatan: tbt_selatan,
      tanda2BatasTanahBarat: tbt_barat,
      alasanTidakAda: alasan_tidak_ada,
      alasanTidakAdaP: alasan_tidak_ada_p,
      sebabLain: alasan_tidak_ada_note,
      keteranganBeton: dk_ket_beton,
      keteranganBetonSebutkan: dk_ket_beton_note,
      peruntukkanPenggunaanBmd: dk_peruntukan_bmd,
      ukuran: UKURAN?.toString().replace('.', ','),
      satuan: SATUAN,
      kesesuaianUkuran: diMUkuran || '',
      satuanSeharusnya,
      ukuranSeharusnya: diMUkuranA,
      namaSpesifikasiBarang: diNmSpesifikasiBarang || '',
      alamat: ALAMAT,
      provinsi: di_kd_prop,
      kabKota: di_kd_rayon,
      kecamatan: di_kd_kec,
      kelurahan: di_kd_kel,
      kodePos: diKodepos || '',
      jalan: diJalan || '',
      noAlamat: diNoJalan,
      rt: diRt || '',
      rw: diRw || '',
      gedungBangunanTanahMilik: diGedungBangunanDiatasTanahMilik,
      isGedungBangunanTanahMilikTercatat,
      gedungBangunanTanahMilikPdUkpd,
      gedungBangunanTanahMilikKobar,
      gedungBangunanTanahMilikRegister,
      gedungBangunanTanahMilikKeterangan,
      gedungBangunanTanahMilikSebutkan,
      isIndikasiGanda: diIndikasiGanda || '',
      indikasiGandaDengan: diIndikasiGandaDengan,
      indikasiGandaSebutkan: diIndikasiGandaSebutkan,
      indikasiGabungan: diIndikasiGabungan,
      indikasiGabunganKeterangan,
      skPenggunaan: diMSkPenggunaan || '',
      nomorSkPenggunaan: di_sk_penggunaan_no,
      tahunSkPenggunaan: di_sk_penggunaan_tahun,
      penggunaan: di_penggunaan,
      digunakanBersama,
      pdUkpd,
      digunakanUntuk,
      pemanfaat,
      isLantaiDigunakan: diMLantaiTdk || '',
      jumlahSeluruhLantai: diMBertingkatA
        ? (parseInt(diMBertingkatA, 10) + 1).toString()
        : '',
      jumlahLantaiDigunakan: diMLantaiTdkUse,
      isAtapBeton: di_pp_at_ada,
      isAtapBetonIsDigunakan: di_pp_at_ada_digunakan,
      isBasement: di_pp_bm_ada,
      isBasementIsDigunakan: di_pp_bm_ada_digunakan,
      isHalamanUtama: di_pp_ht_ada,
      isHalamanUtamaIsDigunakan: di_pp_ht_ada_digunakan,
      jumlahLantaiTidakDigunakan: diMLantaiTdkNot,
      atapBetonDigunakan: di_pp_at_ada_digunakan_oleh,
      basementDigunakan: di_pp_bm_ada_digunakan_oleh,
      halamanUtamaDigunakan: di_pp_ht_ada_digunakan_oleh,
      isBertingkat: diMBertingkat || '',
      pengamananFisik: di_pengamanan_fisik,
      fisikDikuasai: di_pengamanan_fisik_child,
      fisikDikuasaiSebutkan: di_pengamanan_fisik_note,
      fisikTidakDikuasaiSebutkan: di_pengamanan_fisik_note,
      dataGedungBangunanTanahMilikKobar,
      dataGedungBangunanTanahMilikRegister,
      dataKobar,
    }
  }
}
